
export default [
  {
    _name: 'CSidebarNav',
    _children: [
      {
        _name: 'CSidebarNavItem',
        name: 'Dashboard',
        to: '/dashboard',
        icon: 'cil-speedometer',
        badge: {
          color: 'primary',
          text: 'NEW'
        }
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['Feature']
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Career',
        route: '/career',
        icon: 'cil-drop',
        items: [
          {
            name: "Division",
            to: "/career/division"
          },
          {
            name: 'Job',
            to: '/career/Job'
          },
          {
            name: 'Applicant',
            to: '/career/applicant'
          },
          {
            name: 'Employee Branding',
            to: '/career/employee-branding'
          },
        ]
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Shortlink',
        to: '/management/shortlink',
        icon: 'cil-link'
      },
    ]
  }
]
